import { APPLICATION_CONTEXTS } from '../constants';

export const Application = {
  currentContext: APPLICATION_CONTEXTS.SERVICES,
  currentPatient: 'default'
};
